var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrozenCpyAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49988 2.5V0.625C2.49988 0.279825 2.7797 0 3.12488 0H10.6249C10.9701 0 11.2499 0.279825 11.2499 0.625V9.375C11.2499 9.72019 10.9701 10 10.6249 10H8.74988V11.8744C8.74988 12.2199 8.46869 12.5 8.12062 12.5H0.629162C0.281619 12.5 0 12.2221 0 11.8744L0.00162497 3.12554C0.00168747 2.78007 0.2829 2.5 0.630887 2.5H2.49988ZM3.74987 2.5H8.74988V8.75H9.99988V1.25H3.74987V2.5Z",
    fill: "#2B3990"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozenCpyAddress);
export default __webpack_public_path__ + "static/media/frozen-cpy-address.38867eff9d68e70c354d3904cf9881f9.svg";
export { ForwardRef as ReactComponent };